export default {
    "name": "UpdateStore",
    "kind": "HoudiniMutation",
    "hash": "d1f980d592d7d3d447d088908a5c605d938b611fee36490a811bd93a9836b8fa",

    "raw": `mutation UpdateStore($input: StoreUpdate!) {
  updateStore(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateStore": {
                "type": "Store",
                "keyRaw": "updateStore(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "StoreUpdate"
        },

        "types": {
            "AddressServiceUpdate": {
                "apiKey": "String",
                "service": "AddressServiceEnum"
            },

            "TaxServiceUpdate": {
                "apiKey": "String",
                "service": "TaxServiceEnum"
            },

            "StoreUpdate": {
                "address": "String",
                "addressService": "AddressServiceUpdate",
                "city": "String",
                "code": "String",
                "country": "String",
                "fax": "String",
                "id": "Int",
                "invoiceMemo": "String",
                "name": "String",
                "phone": "String",
                "private": "Boolean",
                "remittanceAddress": "String",
                "remittanceCity": "String",
                "remittanceCountry": "String",
                "remittancePhone": "String",
                "remittanceState": "String",
                "remittanceZip": "String",
                "state": "String",
                "taxService": "TaxServiceUpdate",
                "webAddress": "String",
                "zip": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=4a7b673e378d99584d452526b9274bccb3fc82865cbf9cf9bacac1d208eba109";